import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MosquitoLanding from "./Components/MosquitoLanding";
import InteriorLanding from "./Components/InteriorLanding";
import PestControlSection from "./Components/PestControlSection";
import Footer from "./Components/Footer.js";
import AppNavbar from "./Components/AppNavbar.js";
import FloatingButtons from "./Components/FloatingButtons.js";
import AboutUs from "./Components/AboutUs.js";
import OurService from "./Components/OurService.js";
import Home from "./Components/Home.js";
import ContactUs from "./Components/ContactUs.js";
import WhyChooseUs from "./Components/WhyChooseUs.js";
import TestimonialSection from "./Components/TestimonialSection.js";
import FAQSection from "./Components/FAQSection.js";
import HousekeepingLanding from "./Components/HousekeepingLanding.js";
import SecurityLanding from "./Components/SecurityLanding.js";


function App() {
  return <>
    <Router>
      <AppNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/mosquito" element={<MosquitoLanding />} />
        <Route path="/interior" element={<InteriorLanding />} />
        <Route path="/services" element={<OurService />} />
        <Route path="/pest-control" element={<PestControlSection />} />
        <Route path="/housekeeping" element={<HousekeepingLanding/>} />
        <Route path="/security" element={<SecurityLanding/>} />
        <Route path="/whychooseus" element={<WhyChooseUs />} />
        <Route path="/faqs" element={<FAQSection />} />
        <Route path="/testimonials" element={<TestimonialSection />} />

      </Routes>
      <FloatingButtons />
      <Footer/>
    </Router>
  </>
}

export default App;
